import { useState } from "react";
import { Box, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material"
import { formatCurrency } from "../../../common/Helper"

const VIEWS = [
	{ id: 'allocation', label: 'Alocação' },
	{ id: 'position',   label: 'Posição'  },
	{ id: 'retorno',    label: 'Retorno'  },
]

const AssetTypeDetails = ({data}) => {

	const [view, setView] = useState('allocation')

	const total = data.reduce((acc, item) => acc + Number(item.value || 0), 0)

	const rows = data.map((row) => {
		const value           = Number(row.value || 0)
		const cost            = Number(row.cost || 0)
		const quantity        = Number(row.quantity || 0)
		const valueOnCurrency = Number(row.valueOnCurrency ?? value)
		const impliedRate     = valueOnCurrency > 0 ? value / valueOnCurrency : 1
		const costInBRL       = cost * impliedRate
		const percent         = total > 0 ? (value / total) * 100 : 0
		const diff            = percent - Number(row.target)
		const returnPct       = cost > 0 ? ((valueOnCurrency - cost) / cost) * 100 : 0
		const avgCostInBRL    = quantity > 0 ? costInBRL / quantity : 0
		return { ...row, percent, diff, returnPct, avgCostInBRL, costInBRL }
	})

	const sortedRows = view === 'position'
		? [...rows].sort((a, b) => b.value - a.value)
		: view === 'retorno'
		? [...rows].sort((a, b) => b.returnPct - a.returnPct)
		: [...rows].sort((a, b) => a.diff - b.diff)

	const formatDiff   = (v) => `${v > 0 ? '+' : ''}${v.toFixed(2)}%`
	const diffColor    = (v) => v > 0 ? 'success.main' : v < 0 ? 'error.main' : 'text.secondary'
	const returnColor  = (v) => v >= 0 ? 'success.main' : 'error.main'

	return (
		<Box height={'100%'} sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				marginBottom={1}
				flexWrap="wrap"
				gap={1}
			>
				<Typography variant="h6">Detalhamento dos ativos</Typography>
				<ToggleButtonGroup
					value={view}
					exclusive
					onChange={(_, newView) => { if (newView) setView(newView) }}
					size="small"
				>
					{VIEWS.map(v => (
						<ToggleButton
							key={v.id}
							value={v.id}
							sx={{ fontSize: '0.65rem', py: 0.25, px: 1.25, textTransform: 'none' }}
						>
							{v.label}
						</ToggleButton>
					))}
				</ToggleButtonGroup>
			</Box>
			<Divider sx={{ marginBottom: 2 }} />
			<TableContainer sx={{ flex: 1, overflowY: 'auto' }}>
				<Table size="small" stickyHeader>
					<TableHead>
						<TableRow>
							<TableCell>Ticker</TableCell>
							{view === 'allocation' && <>
								<TableCell align="right">Posição</TableCell>
								<TableCell align="center">Alvo</TableCell>
								<TableCell align="center">% portfólio</TableCell>
								<TableCell align="center">Dif. vs alvo</TableCell>
							</>}
							{view === 'position' && <>
								<TableCell align="right">Posição</TableCell>
								<TableCell align="center">Qtd.</TableCell>
								<TableCell align="right">Preço Médio</TableCell>
							</>}
							{view === 'retorno' && <>
								<TableCell align="right">Posição</TableCell>
								<TableCell align="right">Custo</TableCell>
								<TableCell align="center">Retorno</TableCell>
							</>}
						</TableRow>
					</TableHead>
					<TableBody>
						{sortedRows.map((row) => (
							<TableRow key={row.identificator}>
								<TableCell>{row.identificator}</TableCell>
								{view === 'allocation' && <>
									<TableCell align="right">{formatCurrency(row.value)}</TableCell>
									<TableCell align="center">{row.target}%</TableCell>
									<TableCell align="center">{row.percent.toFixed(2)}%</TableCell>
									<TableCell align="center" sx={{ color: diffColor(row.diff), fontWeight: 600 }}>
										{formatDiff(row.diff)}
									</TableCell>
								</>}
								{view === 'position' && <>
									<TableCell align="right">{formatCurrency(row.value)}</TableCell>
									<TableCell align="center">{Math.round(row.quantity)}</TableCell>
									<TableCell align="right">{formatCurrency(row.avgCostInBRL, 'SMALL')}</TableCell>
								</>}
								{view === 'retorno' && <>
									<TableCell align="right">{formatCurrency(row.value)}</TableCell>
									<TableCell align="right">{formatCurrency(row.costInBRL)}</TableCell>
									<TableCell align="center" sx={{ color: returnColor(row.returnPct), fontWeight: 600 }}>
										{row.returnPct > 0 ? '+' : ''}{row.returnPct.toFixed(2)}%
									</TableCell>
								</>}
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}

export default AssetTypeDetails
